import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            追剧指南
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            剧集卡片
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base max-w-2xl mx-auto">
            追剧攻略、类型解读、片单推荐，吃瓜视频帮你发现下一部好剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.slice(0, 3).map((card) => (
            <div
              key={card.title}
              className="group cursor-pointer bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={`${card.title} - 吃瓜视频追剧指南`}
                  title={`${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-accent-500 text-white font-medium px-2.5 py-1 rounded-full">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed line-clamp-2">
                  {card.description}
                </p>
              </div>
            </div>
          ))}

          {cardsData.slice(3).map((card) => (
            <div
              key={card.title}
              className="group cursor-pointer bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 sm:col-span-2 lg:col-span-2"
            >
              <div className="flex flex-col md:flex-row">
                <div className="relative w-full md:w-1/2 aspect-[3/2] md:aspect-auto overflow-hidden">
                  <img
                    src={card.image}
                    alt={`${card.title} - 吃瓜视频追剧指南`}
                    title={`${card.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-xs bg-accent-500 text-white font-medium px-2.5 py-1 rounded-full">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="w-full md:w-1/2 p-5 md:p-6 flex flex-col justify-center">
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}